import { Module } from '@nestjs/common'
import { CustomerReviewsController, StatisticsController } from './controllers'
import { ReportingCronModule } from './cron'
import { StatisticsService } from './services'

@Module({
	imports: [ReportingCronModule],
	controllers: [StatisticsController, CustomerReviewsController],
	providers: [StatisticsService],
})
export class ReportingModule {}
